import type { JSX, ReactNode } from 'react';

import { AuthBridge } from './AuthBridge';
import { QueryProvider } from './QueryProvider';
import { SessionLoader } from './SessionLoader';
import { StoreProvider } from './StoreProvider';
import { ThemeProvider } from './ThemeProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Composición de providers raíz. El orden importa:
 *   StoreProvider          ← Redux disponible para todo lo de adentro
 *     └ AuthBridge         ← conecta axios ↔ store (token + handler 401)
 *       └ QueryProvider    ← TanStack Query
 *         └ ThemeProvider  ← lee el slice ui del store
 *           └ SessionLoader ← /auth/me al boot — necesita store + queryClient
 *             └ children
 */
export function AppProviders({ children }: AppProvidersProps): JSX.Element {
  return (
    <StoreProvider>
      <AuthBridge>
        <QueryProvider>
          <ThemeProvider>
            <SessionLoader>{children}</SessionLoader>
          </ThemeProvider>
        </QueryProvider>
      </AuthBridge>
    </StoreProvider>
  );
}
